module.exports = __webpack_public_path__ + "3d827e28eab9ad85a63b3c1f8d159a53.svg";